// 异步调用后台接口
import axios from 'axios';
import { stringify } from 'qs';
import AppCore from '@/appcore';
import { getValueFromUA } from '@/asset/js/utils';

export const fetchData = async (method, url, params, options, isEncrypt = false) => {
  // console.log('***************fetchData***************');
  // console.log(method, url, params, options, 'fetchData');
  // console.log('***************fetchData***************');
  try {
    let result = {};
    if (method === 'POST') {
      if (isEncrypt) {
        const postData = url.split('?data=');
        const decodedData = decodeURIComponent(postData[1]);
        const urls = postData[0];
        try {
          result = await axios.post(urls, decodedData, options);
        } catch (e) {
          console.log(e, 'e');
        }
      } else {
        result = await axios.post(url, { ...params }, options);
      }
    } else if (method === 'GET') {
      if (isEncrypt) {
        result = await axios.get(url, options);
      } else {
        result = await axios.get(`${url}?${stringify({ ...params })}`, options);
      }
    } else if (method === 'PUT') {
      result = await axios.put(url, { ...params }, options);
    }
    const { code, message, body, headers } = result;
    if (code === 1 || code === '1') {
      return { data: body, headers };
    }
    return { error: message || 'ajax.system', code: code, data: body, headers };
  } catch (error) {
    console.log(error);
    return { error: error };
  }
};

export const fetchDataWithEncrypt = async (method, url, params, options = {}) => {
  try {    
    // 第一步：加密URL和参数
    const encryptResult = await AppCore.webEncryptUrl(params, url);
    // console.log('加密结果:', encryptResult);
    const { authKey, encryptedUrl } = encryptResult;
    
    if (method === 'POST') {
      // 设置请求头
      options.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
      };
    }

    
    if (authKey) {
      options.headers = {
        ...options.headers,
        'x-auth-key': authKey
      };
    }
    
    // 第二步：发送加密请求
    // console.log('准备发送请求到:', encryptedUrl);
    const result = await fetchData(method, encryptedUrl, params, options, true);
    // console.log('fetchData result:', result);
    
    // 第三步：解密响应数据
    const xAuthKey = result.headers?.['x-auth-key'] || result.headers?.['X-Auth-Key'];
    
    if (xAuthKey && result?.data) {
      try {
        const decryptedData = await AppCore.webDecretedData(xAuthKey, result.data);
        
        if (decryptedData) {
          const dt = JSON.parse(decryptedData);
          // console.log(dt, 'dwacsdcecrypted ---- data');
          return {
            data: dt.body,
            error: dt.message,
            code: dt.code,
          };
        }
      } catch (decryptError) {
        console.error('解密失败:', decryptError);
        // 解密失败，使用原始数据
        console.log('decryption failed, using original data:', result);
        return {
          data: result.data,
          error: result.error || 'Request failed',
          code: result.code,
        };
      }
    }
    
    // 如果没有加密密钥或数据，直接返回原始结果
    return {
      data: result.data,
      error: result.error,
      code: result.code,
    };
    
  } catch (error) {
    console.error('fetchDataWithEncrypt error:', error);
    
    // 如果加密流程失败，降级到普通的 fetchData
    try {
      console.log('降级到普通请求:', url);
      return await fetchData(method, url, params, options);
    } catch (fallbackError) {
      console.error('降级请求也失败:', fallbackError);
      return { error: error.message || '请求失败', data: null };
    }
  }
};

export async function uploadImage(params) {
  return await axios.post('/api/cms/image', params, {
    headers: {
      adminName: 'wap'
    }
  });
}

const platform = getValueFromUA('appPlatform') === 'android' ? 1 : 2;
const appPlatform = getValueFromUA('appPlatform') === 'android' ? 1 : 2;

export const getUserInfoById = async params =>
  fetchData('GET', '/api/user/snackUser/getUserInfoById', params);

export const getShareUserInfoById = async params =>
  fetchData('GET', '/api/user/snackUser/share/userInfo', params);

export const getRoomInfo = async params =>
  fetchData('GET', '/api/voice/content/room/share/info', params);

export const feedback = async params => fetchData('POST', '/api/cms/feedback/insert', params);

export const reportRoom = async params => fetchData('POST', '/api/cms/roomReport/insert', params);

export const reportUser = async params => fetchData('POST', '/api/cms/userReport/insert', params);

export const fetchGiftWallList = async params =>
  fetchData('GET', '/api/voice/user/userAssets/getGiftWallInfo', params);

export const fetchGiftWallValue = async params =>
  fetchData('GET', '/api/voice/user/userAssets/getCoinMinValue', params);

export const fetchHaloLevel = async params =>
  fetchData('GET', '/api/voice/user/userCharmLevel/getInfo', params);

export const fetchUserIcon = async params =>
  fetchData('GET', '/api/voice/user/userLevel/getWebInfo', params);

export const fetchHaloIcon = async params =>
  fetchData('GET', '/api/voice/user/userCharmLevel/getWebInfo', params);

export const fetchUserLevel = async params =>
  fetchData('GET', '/api/voice/user/userLevel/getInfo', params);

export const fetchAristocratList = async params =>
  fetchData('GET', '/api/voice/order/product/aristocrat/listV2', params);
export const fetchAristocratUserInfo = async params =>
  fetchData('GET', '/api/voice/user/snackUser/getUserInfoById', params);
export const finishAristocratCoinGet = async params =>
  fetchData('POST', '/api/voice/user/snackUser/clockIn', params);

export const fetchVipUserStatus = async params =>
  fetchData('GET', '/api/voice/user/switch/status/get', params);

export const setVipUserStatus = async params =>
  fetchData('POST', '/api/voice/user/switch/status/update', params);

export const apolloConfig = async params => {
  return await axios.post('/api/message/snackMessage/getApolloConfigByList', params.data);
};

export const getDiamondToMoneyProductList = async params =>
  fetchData('GET', '/api/order/purchase/diamondToMoneyProduct/list', params);

export const getUserAccount = async params =>
  fetchData('GET', '/api/user/userAccount/income', params);

export const fetchRankingList = async params =>
  fetchData('GET', '/api/voice/content/room/membersRank', params);

export const fullTaskInfo = async params => fetchData('GET', '/api/user/task/fullTaskInfo', params);

export const getTaskList = async params =>
  fetchData('GET', '/api/user/task/list', params, {
    headers: {
      appPlatform: getValueFromUA('appPlatform') === 'android' ? 1 : 2
    }
  });

export const getLimitedTaskList = async params =>
  fetchData('GET', '/api/activity/limitedTask/info', params);
export const getLimitedTaskReward = async params =>
  fetchData('POST', '/api/activity/limitedTask/reward', params);

export const luckyGift = async params => fetchData('GET', '/api/voice/user/luckyGift/rank', params);

export const channelBind = async params =>
  fetchData('POST', '/api/order/payout/channelBind', params, {
    headers: {
      platform,
      appPlatform
    }
  });

export const channelList = async params =>
  fetchData('GET', '/api/order/payout/channelList', params, {
    headers: {
      platform,
      appPlatform
    }
  });

export const channelUnbind = async params =>
  fetchData('GET', '/api/order/payout/channelUnbind', params, {
    headers: {
      platform,
      appPlatform
    }
  });

export const channelBindConfig = async params =>
  fetchData('GET', '/api/order/payout/channelBindConfig', params, {
    headers: {
      platform,
      appPlatform
    }
  });

export const tvStatus = async params => fetchData('GET', '/api/user/tvWall/status/modify', params);

export const tvConfig = async params => fetchData('GET', '/api/user/config/info', params);

export const officialPayInfo = async params =>
  fetchData('GET', '/api/order/payChannel/official/channelInfo', params);

export const officialPayChannel = async params =>
  fetchData('GET', '/api/order/payChannel/official/list/v6', params);

export const coinList = async params =>
  fetchData('GET', '/api/order/product/official/coin/sort/list', params);

export const orderInit = async params =>
  fetchData('POST', '/api/order/wap/init', params, {
    headers: {
      appPlatform: 3
    }
  });

export const rechargeResult = async params => fetchData('GET', '/api/order/rechargeResult', params);

export const airtelPay = async params => fetchData('GET', '/api/order/purchase/airtel/pay', params);

export const airtelCheck = async params =>
  fetchData('GET', '/api/order/purchase/airtel/check', params);

export const signInList = async params =>
  fetchData('GET', '/api/content/signIn/list', params, {
    headers: {
      appPlatform
    }
  });
export const couponRecommend = async params => {
  const curParams = { orderId: params.orderId, refer: params.refer, userId: params.userId, sig: params.sig };
  return fetchData('GET', '/api/order/coupon/recommend', curParams, {
    headers: {
      Authorization: params.token,
    },
  });
};

export const goodlucky = async params => fetchData('GET', '/api/game/games/goodlucky/list', params);

export const getFamilyList = async params => fetchData('GET', '/api/voice/user/family/task', params);

export const getFamilyReceive = async params => fetchData('GET', '/api/voice/user/family/receiveTaskReward', params);

export const getFamilyReport = async params => fetchData('GET', '/api/voice/user/family/receive', params);

export const getFamilyRank = async params => fetchData('GET', '/api/voice/user/family/rank', params);

export const followUser = async params => fetchData('POST', '/api/user/snackUser/follow', params);

export const apolloConfigGame = async params => fetchData('GET', '/api/game/games/rankConfig', params);

export const airWallexToken = async (params, userId) =>
  fetchData('GET', '/api/order/wap/airWallex/token', params, {
    headers: {
      userId,
    },
  });

export const validation = async params => fetchData('POST', '/api/order/forter/validation', params);

export const mpesaPay = async params => fetchData('GET', '/api/order/purchase/mpesa/pay', params);

export const mpesaCheck = async params => fetchData('GET', '/api/order/purchase/mpesa/check', params);

export const receiveList = async params => fetchData('GET', '/api/voice/content/room/giftRank', params);

// 提现
export const incomeShowInfo = async params => fetchDataWithEncrypt('GET', '/api/user/dynamic/assign/userAccount/revenueDisplayDetails', params);

export const productList = async params => fetchDataWithEncrypt('GET', '/api/order/dynamic/assign/payout/item/list', params);

export const getDiamondExchangeInfo = async params => fetchDataWithEncrypt('GET', '/api/user/dynamic/assign/userAccount/retrieveGemSwapInfo', params);

export const diamondExchangeCoins = async params => fetchDataWithEncrypt('POST', '/api/user/dynamic/assign/userAccount/gemSwapTokens', params);

export const recentlyUsed = async params => fetchDataWithEncrypt('GET', '/api/order/dynamic/assign/payout/route/frequentlyAccessed', params);

export const payoutchannelList = async params => fetchDataWithEncrypt('GET', '/api/order/dynamic/assign/payout/routeCollection', params);

export const channelSelect = async params => fetchDataWithEncrypt('GET', '/api/order/dynamic/assign/payout/route/chosen', params);

export const payoutSubmit = async params => fetchDataWithEncrypt('POST', '/api/order/dynamic/assign/payout/send', params);

export const recordList = async params => fetchDataWithEncrypt('GET', '/api/order/dynamic/assign/payout/report/list', params);

export const getShowTask = async params => fetchDataWithEncrypt('GET', '/api/user/dynamic/assign/task/meTask/list', params);

// 官网充值
export const rechargeAward = async params => fetchData('POST', '/api/order/payChannel/official/rechargeAward/receive', params);

export const customizeList = async params => fetchData('GET', '/api/user/customize/list', params);

export const customizeDaysum = async params => fetchData('GET', '/api/user/customize/daysum', params);

export const customizeRewards = async params => fetchData('GET', '/api/user/customize/rewards', params);

export const chatList = async params => fetchData('GET', '/api/message/customize/list', params);

export const getUrl = async params => axios.post('/api/message/snackMessage/getApolloConfigByList', params);

export const diamondToMoneyRatio = async params => fetchData('GET', '/api/message/diamondIncome/diamondToMoneyRatio', params);

export const getRecommendList = async params => fetchData('GET', '/api/voice/user/family/getRecommendListV2', params);

export const bannerList = async params => fetchData('GET', '/api/voice/content/index/banner', params);

export const familyJoin = async params => fetchData('POST', '/api/voice/user/family/join', params);

export const getJoinFamilyInfo = async params => fetchData('GET', '/api/voice/user/family/getJoinFamilyInfo', params);

export const specialOfferList = async params => fetchData('GET', '/api/order/payChannel/official/specialOfferList', params);
